import { IconEdit01, IconTrash01 } from "@pentabd/icons";

type TableActionsProps = {
  onClickEdit: () => void;
  onClickDelete: () => void;
};

export default function TableActions({
  onClickDelete,
  onClickEdit,
}: TableActionsProps) {
  const commonStyles = {
    cursor: "pointer",
  };
  return (
    <div
      className="d-flex gap-3 
align-items-center"
    >
      <div onClick={() => onClickEdit && onClickEdit()} style={commonStyles}>
        <IconEdit01 size={20} fill="subtitle1" />
      </div>
      <div
        onClick={() => onClickDelete && onClickDelete()}
        style={commonStyles}
      >
        <IconTrash01 size={20} fill="danger" />
      </div>
    </div>
  );
}
